import React from 'react';
import styled from 'styled-components';

import PoiHeader from './components/PoiHeader.tsx';
import { getSectionWidget } from './poiSections.ts';

const InnerLayoutStyled = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ScrollableContent = styled.div`
  padding: 12px 12px 0;
  overflow-y: auto;
  position: relative;
`;

export const PoiViewWidgetDesktopImpl = ({
  className,
  poi,
  layout,
  T,
  venueCategory,
  venueTimezone,
  openStatus,
  lang,
  structures,
  submitAnalyticsEvent,
  submitAnalyticsEventWithAppInsights,
  submitReserveParkingClick,
  searchInputsLength,
  hidePoiFeedback,
  venueId,
}) => {
  return (
    <InnerLayoutStyled className={className} data-testid="PoiViewWidgetDesktop">
      <ScrollableContent>
        <PoiHeader poi={poi} T={T} />
        {layout.map(sectionName => {
          const $Component = getSectionWidget(sectionName);
          return $Component ? (
            <$Component
              key={sectionName}
              poi={poi}
              T={T}
              venueCategory={venueCategory}
              venueTimezone={venueTimezone}
              openStatus={openStatus}
              structures={structures}
              lang={lang}
              submitAnalyticsEvent={submitAnalyticsEvent}
              submitAnalyticsEventWithAppInsights={submitAnalyticsEventWithAppInsights}
              onSubmit={submitReserveParkingClick}
              searchInputsLength={searchInputsLength}
              hidePoiFeedback={hidePoiFeedback}
              venueId={venueId}
            />
          ) : null;
        })}
      </ScrollableContent>
    </InnerLayoutStyled>
  );
};

export default PoiViewWidgetDesktopImpl;
